import React, { useEffect, useState } from "react";
import "../../firm.css";
import "react-phone-input-2/lib/style.css";
import { ACTIONS } from "../../../../constants/Constants";
import { t } from "i18next";
import { PrimaryButton } from "@fluentui/react";

const HeaderFooterImage = (props) => {

  const allowedFileTypes = [
    ".JPEG",
    ".jpeg",
    ".PNG",
    ".png",
    ".JPG",
    ".jpg"
  ];

  const [headerImage, setHeaderImage] = useState(props.headerImageValue ? true : false);
  const [footerImage, setFooterImage] = useState(props.footerImageValue ? true : false);

  return (
    <>
      <div className="">
        <div className="form-section-header" style={{marginTop: "15px", marginBottom: "10px"}}>
          <span style={{ marginBottom: "20px", fontSize: "20px" }}>{props.headerName}</span>
        </div>
        {(props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT) &&
          !props.editConfigurationSetting && (
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                  <div
                    className="headerImageContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <label>Header Image:</label>
                  <div>
                    {(props.headerImageValue != null &&  props.headerImageValue != "" && headerImage && props.values.reportHeaderDto.isHeaderImageDeleted == 0) &&(
                        <img
                          id=""
                          src={props.headerImageValue}
                          height={"150px"}
                      />
                      )}
                    </div>
                    <div>
                      <input
                        style={{ width: "112px", overflow: "hidden" }}
                        id="headerImage"
                        type="file"
                        name="headerImage"
                        title="Choose a file please"
                        onChange={(ev) => {
                          props.setHeaderImageFileName(ev.target.files[0].name);
                          props.values.reportHeaderDto.headerImage =
                            ev.target.files[0];
                          props.values.reportHeaderDto.isHeaderImageDeleted = 0;
                          props.setIsHeaderFileDeleted(false);
                          ev.target.value = null;
                        }}
                        className="file-input-container"
                        accept={allowedFileTypes.join(",")}
                      />
                      <label style={{ marginLeft: "10px" }} for="headerImage">
                        {props.headerImageFileName}
                    </label>

                    {(((props.headerImageValue != null && props.headerImageValue != "" && headerImage) || (props.headerImageFileName != null && props.headerImageFileName != "")) && (props.values.reportHeaderDto.isHeaderImageDeleted == 0)  ) &&(
                      <PrimaryButton
                        text="Clear Header Image"
                        className="study-list-clear-all-button"
                        onClick={() => {
                          props.handleClearImage("header")
                          setHeaderImage(false);
                        }
                      }
                    />)}
                    </div>
                  </div>
                </div>
              </div>
              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                  <div
                    className="headerImageContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <label>Footer Image:</label>
                  <div>
                      {((props.footerImageValue != null && props.footerImageValue != ""  && footerImage && props.values.reportHeaderDto.isFooterImageDeleted == 0)) &&(
                        <img
                          id=""
                          src={props.footerImageValue}
                          height={"150px"}
                          width={"835px"}
                        />)}
                    </div>
                    <div>
                      <input
                        style={{ width: "112px", overflow: "hidden" }}
                        id="footerImage"
                        type="file"
                        name="footerImage"
                        onChange={(ev) => {
                          props.setFooterImageFileName(ev.target.files[0].name);
                          props.values.reportHeaderDto.footerImage =
                            ev.target.files[0];
                            props.values.reportHeaderDto.isFooterImageDeleted = 0;
                          props.setIsFooterFileDeleted(false);
                          ev.target.value = null;
                        }}
                        className="file-input-container"
                        accept={allowedFileTypes.join(",")}
                      />
                      <label style={{ marginLeft: "10px" }} for="footerImage">
                        {props.footerImageFileName}
                    </label>
                    {(((props.footerImageValue != "" && props.footerImageValue != null && footerImage) || (props.footerImageFileName != null && props.footerImageFileName != "")) && (props.values.reportHeaderDto.isFooterImageDeleted == 0) ) && (
                      <PrimaryButton
                      text="Clear Footer Image"
                      className="study-list-clear-all-button"
                      onClick={() => {
                        props.handleClearImage("footer")
                        setFooterImage(false);
                      }
                    }
                    />)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        {props.action === ACTIONS.VIEW && (
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div
                  className="headerImageContainer"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <label>Header Image:</label>
                  <div>
                    {props.headerImageValue != "" ? (
                      <img
                        id=""
                        src={props.headerImageValue}
                        height={"150px"}
                      />
                    ) : (
                        <div>{t("hospital.no-image-found")}</div>
                      )}
                  </div>
                  {/* <input
                          id="headerImage"
                          type="file"
                          name="headerImage"
                          onChange={(ev) => {
                            props.values.reportHeaderDto.headerFile =
                            ev.target.files[0];
                          }}
                        /> */}
                </div>
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div
                  className="headerImageContainer"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <label>Footer Image:</label>
                  <div>
                    {props.footerImageValue != "" ? (
                      <img
                        id=""
                        src={props.footerImageValue}
                        height={"150px"}
                        width={"835px"}
                      />
                    ) : (
                        <div>{t("hospital.no-image-found")}</div>
                    )}
                  </div>
                  {/* <input
                          id="footerImage"
                          type="file"
                          name="footerImage"
                          onChange={(ev) => {
                            props.values.reportHeaderDto.footerFile =
                            ev.target.files[0];
                          }}
                        /> */}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default HeaderFooterImage;
